<template>
  <u-form :state="state" :schema="schema" @submit="saveTag" ref="form" :validate-on="['submit']">
    <core-modal-header v-if="modal">{{isEditing ? 'Edit Tag' : 'Create Tag'}}</core-modal-header>

    <component :is="modal ? CoreModalBody : 'div'">
      <u-form-group label="Tag Name" name="name" required>
        <u-input placeholder="Enter tag name..." autofocus v-model="state.name" />
      </u-form-group>
    </component>

    <component :is="modal ? CoreModalFooter : 'div'" :class="modal ? '' : 'pt-6 text-right'">
      <u-button color="charcoal" variant="ghost" v-if="modal" @click="modal.close()">Cancel</u-button>
      <u-button type="submit" :disabled="!isDirty" :loading="isSaving">{{isEditing ? 'Update Tag' : 'Create New Tag'}}</u-button>
    </component>
  </u-form>
</template>

<script setup>
  import {object, string} from 'yup';
  import {CoreModalBody, CoreModalFooter} from '#components';

  const emit = defineEmits(['success']);
  const props = defineProps({
    tag: Object,
    modal: Object
  });

  const form = ref();
  const state = ref(Object.assign({name: null}, props.tag));
  const isSaving = ref(false);
  const isEditing = Boolean(props.tag);
  const isDirty = computed(() => state.value.name !== props.tag?.name);

  const schema = object({
    name: string().required('This field is required.').max(TAG_MAX_LENGTH, `Max length cannot exceed ${TAG_MAX_LENGTH} characters.`),
  });

  async function saveTag() {
    isSaving.value = true;

    try {
      const newTag = isEditing
        ? await useTagsStore().updateTag({id: state.value.id, updates: state.value})
        : await useTagApi().createTag(state.value);

      useSuccessToast().add({
        id: 'tag-edit-success',
        description: `Your tag ${html2text(state.value.name)} was saved.`,
        actions: [
          !isEditing ? {
            label: 'View Tag',
            click: () => navigateTo(useBuildRoute().toTag({tag: newTag}))
          } : null
        ].filter(Boolean)
      });

      emit('success', {newTag});
    } catch (e) {
      if (e.statusCode === 409) {
        form.value.setErrors([
          {
            message: 'This tag already exists.',
            path: 'name'
          }
        ])
      } else {
        useErrorToast().add();
      }
    } finally {
      isSaving.value = false;
    }
  }


</script>
